import Image from "next/image";

export default function InfoCard({ number, title, description, imageUrl, imagePosition,imageCar }: {
    number: number;
    title: string;
    description: string;
    imageUrl: string;
    imagePosition: "left" | "right";
    imageCar: string;
}) {
    return (
        <div className="flex max-w-screen-2xl mx-auto gap-6 items-center ">

            {imagePosition === "left" && (
                <div className="flex-shrink-0 max-sm:hidden">
                    <Image
                        src={imageCar}
                        alt={title}
                        width={380}
                        height={320}
                        className="rounded-xl object-cover"
                    />
                </div>
            )}

            <div className={`${imagePosition === "left" ? " max-sm:flex-col-reverse" : ""} p-6 max-sm:m-4 flex flex-col md:flex-row items-center gap-x-4 bg-[#F8F9FD] border border-[#DBDBDB]  rounded-[42px] shadow-md `}>
                {imagePosition === "left" && (
                    <div className="flex-shrink-0  ">
                        <Image
                            src={imageUrl}
                            alt={title}
                            width={380}
                            height={320}
                            className="rounded-xl object-cover"
                        />
                    </div>
                )}
                <div className={`flex ${imagePosition === "left" ? "flex-row-reverse max-sm:flex-row" : ""} max-sm:gap-x-2 gap-x-6 items-start  max-sm:pb-5`}>
                    <div className="flex items-center gap-4">
                        <div className="max-sm:text-3xl font-normal max-sm:w-16 max-sm:h-16 w-24 h-24 flex items-center justify-center border border-[#DBDBDB] bg-white rounded-full text-5xl ">
                            {number}
                        </div>
                    </div>
                    <div className="flex flex-col">
                        <h3 className="max-sm:text-[26px] text-[34px] font-normal">{title}</h3>
                        <p className="max-sm:text-xl text-2xl md:leading-[140%] text-gray-600 mt-2">{description}</p>
                    </div>
                </div>
                {imagePosition === "right" && (
                    <div className="flex-shrink-0 ">
                        <Image
                            src={imageUrl}
                            alt={title}
                            width={380}
                            height={320}
                            className="rounded-xl object-cover"
                        />
                    </div>
                )}
            </div>

            {imagePosition === "right" && (
                <div className="flex-shrink-0 max-sm:hidden">
                    <Image
                        src={imageCar}
                        alt={title}
                        width={380}
                        height={320}
                        className="rounded-xl object-cover"
                    />
                </div>
            )}
        </div>

    );
}
